import type { InjectionKey } from 'vue'

export const pillGroupKey: InjectionKey<PillGroupContext> = Symbol('pillgroup')

export interface PillGroupContext {
  model: any
  /** Call to set the model value */
  setValue: (value: any) => void
  /**
   * Returns `true` if the passed value is selected. Handles both array and
   * primitive values.
   */
  isSelected: (value: any) => boolean
  /**
   * Indicates if the controller allows multiple selections.
   */
  multiple: boolean
}
